import { Component, inject } from '@angular/core';
import { ButtonComponent } from "../../components/buttons/button.component";
import { Router } from '@angular/router';

@Component({
  selector: 'app-page-not-found',
  standalone: true,
  imports: [ButtonComponent],
  templateUrl: './page-not-found.component.html'
})
export class PageNotFoundComponent {
  private readonly route = inject(Router);

  goToHome(){
    this.route.navigate(['/home']);
  }

}
